import React from 'react';
import { Collapse } from '@mui/material';
import GroupRow from '../row';
import { Props } from '../props';

export default function GroupTree({
  groups,
  expanded,
  onClick,
  level,
}: Props): JSX.Element {
  return (
    <>
      {groups.map(group => (
        <div key={group.id}>
          <GroupRow group={group} level={level} onClick={onClick} />
          {group.subGroups && group.subGroups.length > 0 && (
            <Collapse in={expanded}>
              <GroupTree
                groups={group.subGroups}
                expanded={expanded}
                level={level + 1}
                onClick={onClick}
              />
            </Collapse>
          )}
        </div>
      ))}
    </>
  );
}
